module.exports = __webpack_public_path__ + "static/media/skins.e07fb1be.png";